<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-actions">

                            <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                                <div class="row align-items-end">
                                    <div class="col-12 col-sm-8 card-header-search-box">
                                        <div class="input-group">
                                            <input class="form-control search-input" type="text"
                                                   :placeholder="$t('main.search')" v-model="filter.search"
                                                   @keypress.enter="initList">
                                            <div class="input-group-append">
                                                <button class="all-btn search-btn" @click="initList">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                                <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_AUTO_TEX_PASSPORT_ADD')"
                                        @click="addAutoParts">
                                    {{$t("action.add")}}
                                </button>
                            </div>

                        </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th class="text-center">#</th>
                                    <th>{{$t('auto.autoTexPassport.ownerName')}}</th>
                                    <!--<th>{{$t('auto.autoTexPassport.address')}}</th>-->
                                    <th>{{$t('auto.autoTexPassport.governmentNum')}}</th>
                                    <th>{{$t('auto.autoTexPassport.texPassportNumber')}}</th>
                                    <th>{{$t('auto.autoTexPassport.engineNum')}}</th>
                                    <th>{{$t('auto.autoTexPassport.bodyNum')}}</th>
                                    <th>{{$t('auto.autoTexPassport.shasseNum')}}</th>
                                    <th>{{$t('auto.autoTexPassport.autoColor')}}</th>
                                    <th>{{$t('auto.autoTexPassport.fuelType')}}</th>
                                    <th>{{$t('auto.autoTexPassport.madeYear')}}</th>
                                    <th>{{$t('auto.autoTexPassport.innOrPinflNumber')}}</th>
                                    <th>{{$t('auto.autoTexPassport.texPasDataStatus')}}</th>
                                    <th class="text-center">{{$t('client.field.action')}}</th>
                                </tr>
                                </thead>
                                <tbody v-if="!loading && results && results.data">
                                <tr v-for="result in results.data" :key="result.id">
                                    <td>{{result.id}}</td>
                                    <td>{{result.ownerName}}</td>
                                    <!--<td>{{result.address}}</td>-->
                                    <td>{{result.governmentNum}}</td>
                                    <td>{{result.texPassportNum}}</td>
                                    <td>{{result.engineNum}}</td>
                                    <td>{{result.bodyNum}}</td>
                                    <td>{{result.shasseNum}}</td>
                                    <td>{{result.autoColor}}</td>
                                    <td>{{result.fuelType}}</td>
                                    <!--<td>{{result.highWeight}}</td>-->
                                    <td>{{result.madeYear}}</td>
                                    <td v-if="result.identificationNumber" >{{result.identificationNumber}}</td>
                                    <td v-else-if="result.pinflNumber">{{result.pinflNumber}}</td>
                                    <td v-else >---</td>

                                   <td class="badge-info" v-if="result.texpasportDatabaseStatusType==='COMPLETE'">Тўлиқ</td>
                                   <td class="badge-blue" v-else-if="result.texpasportDatabaseStatusType==='PARTIAL'">Қисман тўлиқ</td>
                                   <td v-else>---</td>



                                    <td class="td-actions text-center">
<!--                                        <button @click="onActionEdit('view', result.id)"-->
<!--                                                class="all-btn view-btn table-action"-->
<!--                                        >-->
<!--                                            <i class="fa fa-image"></i>-->
<!--                                        </button>-->
                                        <button  @click="onActionEdit('edit', result.id)"
                                                class="all-btn edit-btn table-action"
                                        >
                                            <i class="fa fa-edit"></i>
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5"
                                  v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                              :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';

    export default {
        components: {
            'b-pagination': bPagination
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
            }
        },
        computed: {},
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('auto_tex_passport/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        console.log("this.results = ", this.results);
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    })
            },

            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            addAutoParts() {
                this.$router.push('/tex-passport/add');
            },
            onActionEdit(action, id) {
                this.$router.push(`/tex-passport/${action}/${id}`);
            }
        },
        created() {
            this.initList()
        }
    }
</script>

<style scoped>

</style>